import React from 'react'
import {translate} from 'react-i18next'
import styled from 'styled-components'

import ButtonIcon from 'components/button/ButtonIcon'
import ButtonChildrenWrapper from 'components/button/ButtonChildrenWrapper'
import ButtonText from './ButtonText'
import ButtonView from './ButtonView'

const Description = styled.p`
  margin: 4px 0 0 0;
  font-size: 12px;
  font-weight: normal;
  padding-left: 12px;
  padding-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Button = ({
  t,
  label,
  description,
  children,
  onClick,
  className,
  color,
  hoverColor,
  activeColor,
  background,
  hoverBackground,
  activeBackground,
  border,
  hoverBorder,
  activeBorder,
  icon,
  hoverIcon,
  iconStyles,
  textStyles = {},
  disabled,
  full,
  type,
  small,
  id,
  isAnimated,
}) => (
  <ButtonView
    id={id}
    onClick={onClick}
    disabled={disabled}
    className={className}
    color={color}
    type={type}
    hoverColor={hoverColor}
    activeColor={activeColor}
    border={border}
    hoverBorder={hoverBorder}
    activeBorder={activeBorder}
    background={background}
    hoverBackground={hoverBackground}
    activeBackground={activeBackground}
    full={full}
    isAnimated={isAnimated}
    small={small}>
    <ButtonChildrenWrapper>
      {icon && <ButtonIcon color={color} icon={icon} hoverIcon={hoverIcon} styles={iconStyles} />}
      <ButtonText icon={icon} styles={textStyles} biometric={description}>
        {t(label || children)}
        {description && <Description>{t(description)}</Description>}
      </ButtonText>
    </ButtonChildrenWrapper>
  </ButtonView>
)

export {Button as PureButton}

export default translate()(Button)
